import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { getClubBySlug } from 'redux/clubs/reducers';

import { validateAddressForNotLoggedInCustomer } from './validators';

class Billing extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, this.props);
    const clubSignup = {
      billTo: data
    };
    props.updateClubSignup(clubSignup);
  };

  handleBack = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('customer');
  };

  render() {
    const { clubSignup, handleSubmit, change, form, settings } = this.props;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (clubSignup.billTo) {
      object = clubSignup.billTo;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Billing address</h3>
        <AddressForm
          object={object}
          changeFunction={change}
          settings={settings}
        />

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Continue to account information
          </button>
          <a onClick={this.handleBack}>Return to customer information</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const address = transformAddressData(values);
  address.customerAddressId = values.customerAddressId;
  return address;
};

const validate = (values, props) => {
  let errors = {};
  const address = transformData(values);
  address.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  address.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  address.birthYear =
    values.birthYear && convertStringToInteger(values.birthYear);
  errors = Object.assign(
    errors,
    validateAddressForNotLoggedInCustomer(address, props.settings)
  );
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const clubSignup = state.clubSignup.data;
  let initialValues = {};
  if (clubSignup) {
    const { billTo } = clubSignup;
    initialValues = Object.assign(initialValues, initialFormValues(billTo));
  }
  if (!initialValues.countryCode) {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    clubSignup: state.clubSignup,
    club: getClubBySlug(state.club, ownProps.match.params.slug),
    customer: state.customer,
    settings: state.setting,
    initialValues
  };
};

Billing = reduxForm({
  form: 'billingNotLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Billing);

export default withRouter(
  connect(mapStateToProps, { updateClubSignup })(Billing)
);
